import { Modal } from './Modal';
import { Avatar, fmt } from '../lib/helpers';

export function SettleUpModal({ balances, people, meId, onSettle, onClose }) {
  const myTxns = balances.transactions.filter(t => t.from === meId || t.to === meId);
  const personById = (id) => people.find(p => p.id === id);

  const handle = async (txn) => {
    if (!window.confirm(`Record payment of ${fmt(txn.amount)}?`)) return;
    await onSettle({ from_person: txn.from, to_person: txn.to, amount: txn.amount });
    onClose();
  };

  return (
    <Modal title="Settle up" onClose={onClose}>
      {myTxns.length === 0 ? (
        <div className="empty">🎉 You're all settled up!</div>
      ) : (
        <div className="settle-list" style={{ marginBottom: 0 }}>
          {myTxns.map((t, i) => {
            const from = personById(t.from);
            const to = personById(t.to);
            if (!from || !to) return null;
            return (
              <div className="settle-row" key={i}>
                <Avatar person={from} />
                <span className="settle-name">{from.name}</span>
                <span className="settle-arrow">→</span>
                <Avatar person={to} />
                <span className="settle-name">{to.name}</span>
                <span className="settle-amount text-red">{fmt(t.amount)}</span>
                <button className="btn" style={{ marginLeft: 4, padding: '4px 10px', fontSize: 12 }} onClick={() => handle(t)}>
                  Settle
                </button>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
}
